module.exports = __webpack_public_path__ + "static/media/post-purchase-page@2x.c9d8f2a3.png";